module.exports = __webpack_public_path__ + "static/assets/7e9fd4a23990a7a8f94c59c2671ecd62.png";